var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13.5,
    r: 12.5,
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3471 18.1128C12.2519 18.1132 14.1568 18.1132 16.0617 18.1128C16.7077 18.1126 17.1479 18.1125 17.5323 18.1803C19.3727 18.5048 20.8135 19.9457 21.138 21.786C21.2058 22.1704 21.2057 22.6107 21.2056 23.2567C21.2056 23.3975 20.1777 23.7607 20.1531 23.9C20.0558 24.4521 20.7052 23.8026 20.1531 23.9C20.2024 23.0398 18.548 24.7809 18.4846 24.7805C14.3031 25.85 11.0531 25.85 6.61716 24.7805C6.55371 24.7809 6.62392 24.5713 6.50286 24.55C5.95077 24.4527 5.95021 24.4521 5.85286 23.9C5.82831 23.7607 5.20317 23.3975 5.20314 23.2567C5.203 22.6107 5.2029 22.1704 5.27068 21.786C5.59518 19.9457 7.03605 18.5048 8.87638 18.1803C9.2608 18.1125 9.70102 18.1126 10.3471 18.1128Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.31473 11.8896C8.31473 9.18916 10.5039 7 13.2044 7C15.9048 7 18.094 9.18916 18.094 11.8896C18.094 14.5901 15.9048 16.7793 13.2044 16.7793C10.5039 16.7793 8.31473 14.5901 8.31473 11.8896Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuProfile);
export default __webpack_public_path__ + "static/media/menu-profile.4fa039f7bd86bd0f195d4420a3c8e4c3.svg";
export { ForwardRef as ReactComponent };